import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Spacing } from '@app/shared/types';

type CardSize = 'none' | 'small' | 'medium' | 'large' | 'xlarge' | 'xxlarge';
type CardStyle = 'all' | 'bottom';

@Component({
  standalone: true,
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css'],
  imports: [CommonModule],
})
export class CardComponent {
  @Input() size: CardSize = 'small';
  @Input() background = false;
  @Input() rounded: CardStyle = 'all';
  @Input() border = true;
  @Input() fullHeight = false;
  @Input() partialFullHeight = false;
  @Input() spacingBottom = Spacing.MEDIUM;
}
